export const PAYMENT_ERROR_COPY = {
  PAYMENT_LINK_CHECK_INVALID: 'This link cannot be checked with Network',
  PAYMENT_LINK_NETWORK_ORDER_REQUIRED: 'This link has no Network order reference. Accounts must reconcile it.',
  PAYMENT_LINK_RETIRE_NOT_AVAILABLE: 'Check with Network first',
  PAYMENT_LINK_RETIRE_INVALID: 'Check the retirement details',
  PAYMENT_REASON_INVALID: 'Choose a valid reason and provide any required note',
  PAYMENT_LINK_VERSION_CONFLICT: 'This link changed — check it again',
  PAYMENT_LINK_RETIRE_KEY_CONFLICT: 'This request key belongs to another retirement. Do not retry with a new key.',
  PAYMENT_LINK_REPLACE_KEY_CONFLICT: 'This request key belongs to another replacement. Do not retry with a new key.',
  PAYMENT_LINK_REPLACEMENT_AMOUNT_CHANGED: 'The fee or total changed. Create a new link instead.',
  PAYMENT_LINK_SETTINGS_INVALID: 'Check the payment-link settings',
  PAYMENT_LINK_SETTINGS_VERSION_CONFLICT: 'These settings changed. Reload and review your changes.',
  PAYMENT_LINK_MIGRATION_REQUIRED: 'Not available yet',
  QUERY_LIFECYCLE_BLOCKED: "Can't do this yet",
  PAYMENT_OR_ARRANGEMENT_REQUIRED: 'Payment or a pay-later/COD arrangement is required',
  INVOICE_NOT_LOCKED: 'Lock the price first',
  BALANCE_PROJECTION_MISSING: 'Payment totals are not available yet',
  BALANCE_PROJECTION_STALE: 'Payment totals need refreshing',
  REVISION_PENDING: 'Finish the price revision first',
  FINANCIAL_EXCEPTION: 'Accounts must review the financial exception',
  MANAGEMENT_APPROVAL_REQUIRED: 'Management approval is required',
  COLLECTION_TASK_IN_PROGRESS: 'A driver is collecting this now. Ask Operations to stop the collection first.',
  PAYMENT_LINK_SEND_RECONCILIATION_REQUIRED: 'Accounts must check the previous send before this link can be sent again',
  PAYMENT_LINK_TEMPLATE_REQUIRED: 'Copy the link and share it from the chat',
  REVISION_APPROVAL_PENDING: 'The price decrease is waiting for approval',
  REVISION_BLOCKED_BY_CHEQUE: 'Accounts must resolve the cheque before accepting this price',
  REVISION_ARRANGEMENT_LINK_ACTIVE: 'Cancel or reconcile the arrangement payment link first',
  USE_INVOICE_REVISION: 'Use Revise price to change a locked invoice',
  FORWARD_MOVE_OWNED_BY_PAYMENTS: 'Customer acceptance and payments control this stage',
  PERMISSION_REQUIRED: 'You do not have permission for this action',
  SETTLEMENT_ACCOUNTS_APPROVAL_REQUIRED: 'This date needs Accounts approval',
  SETTLEMENT_TERMS_INVALID: 'Check the payment-plan terms and required dates',
  SETTLEMENT_TERMS_UNCHANGED: 'These terms are already recorded',
  SETTLEMENT_TERMS_CONFIGURATION_INVALID: 'Accounts must check the payment-plan configuration',
  SETTLEMENT_LINK_AMOUNT_EXCEEDED: 'The amount exceeds the available balance',
  SETTLEMENT_LINK_SCOPE_INVALID: 'This payment plan is no longer available for this invoice',
  SETTLEMENT_LINK_BALANCE_MISSING: 'Refresh the invoice balance before collecting this payment plan',
  SETTLEMENT_LINK_RECEIPT_INVALID: 'Accounts must reconcile the receipt for this payment link',
  PAYMENT_LINK_INVALID: 'Check the payment-link details',
  PAYMENT_LINK_NOT_FOUND: 'This payment link could not be found',
  PAYMENT_LINK_EXPIRY_REQUIRED: 'The payment-link expiry is missing',
  PAYMENT_LINK_SEND_UNCERTAIN: 'The previous send is uncertain. Accounts must reconcile it before another send.',
};
export const paymentError = error => {
  const body = error?.response?.data || {};
  return { code: body.code || body.error?.code || body.data?.code || error?.code || null,
    message: body.message || body.error?.message || error?.message || 'The payment action could not be completed.',
    data: error?.data ?? body.data ?? null };
};
export const paymentErrorMessage = error => {
  const { code, message } = paymentError(error);
  return PAYMENT_ERROR_COPY[code] ? `${PAYMENT_ERROR_COPY[code]}. ${message}` : message;
};

export const paymentErrorStatus = error => Number(error?.status || error?.response?.status || 0);

export const isVersionConflict = error => paymentErrorStatus(error) === 409;

export const isAmbiguousCommandFailure = error => {
  const status = paymentErrorStatus(error);
  return !error?.response || status >= 500;
};

export const paymentErrorCode = error => paymentError(error).code;
